<template>
<div id="edrive_peticiones" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Descarga de Evidencias" class="px-1 py-1" >
          <v-card-text>
           
            <v-layout align-center justify-center>
              <v-flex xs4 style="margin-top:-30px" >
                <v-card class="mx-auto primary" height="550px" max-width="400" >
                  <v-sheet class="pa-5 primary" >
                    <v-row>
                     <v-card-title class="pa-2 white--text" >  Dias Disponibles </v-card-title>
                  <!--     <v-col cols="12" sm="10" lg="10" class="pa-0 ps-3" >
                        <v-text-field style="width:380px;" label="Dias Disponibles" dark text solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline" disabled></v-text-field>
                      </v-col> -->
                   <!--    <v-col cols="12" sm="2" lg="2" class="pa-0 ps-2 pt-1" >
                        <v-btn icon dark v-tippy>
                          <v-icon colorHover="secondary" color="white" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col> -->
                    </v-row>
                  </v-sheet>
                  <v-card-text>
                    <div class="tree" >
                      <div class="contenido" >
                        <v-treeview v-model="tree" :items="items" active-class="secondary lighten-4 indigo--text" :active.sync="active" activatable @update:active="preview" returnObject dense :open-all="items.length==1" :key="key" >
                          <template v-slot:prepend="{ item, open }" >
                            <v-icon v-if="item.file == 'folder' " >{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                            <v-icon v-else>{{ files[item.file.toUpperCase()] }}</v-icon>
                          </template>
                        </v-treeview>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs8 style="margin-top:-30px" >
                <v-card class="mx-auto primary" height="550px" :key="search" v-if="active.length > 0" >
                  <v-card-title class="primary white--text" >
                    <v-icon small class="white--text" >list</v-icon>&nbsp;
                    <span class="subheading" >
                      <strong>Opciones Disponibles{{file}}</strong>
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <br />
                    <table class="table white--text " >
                      <tbody>
                        <tr >
                          <td class="pa-3" >
                            <span id="lab_title_file" >Archivo Zip - Edocuments</span>:
                          </td>
                          <td class="pa-3" >
                            <strong>
                              <span id="lab_file" >{{active[0].name}}</span>
                            </strong>
                          </td>

                       <!--    <td>Tamaño:</td> -->

                        <!--   <td>
                            <strong>
                              <span id="lab_size" >{{active[0].size}} MB</span>
                            </strong>
                          </td> -->

                          <td class="pa-3" >
                            <v-btn rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                              <v-icon small>mdi-download</v-icon> Descargar 
                            </v-btn>
                            <v-btn v-if="borrableExpediente" @click="confirmExpediente = true" rounded x-small color="red" title="Eliminar Expediente" v-tippy>
                              <v-icon small>mdi-trash-can</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="active[0].file.toUpperCase() =='XML' " class="global" >
                      <div class="contenido" >
                        <pre>{{xmlContent}} </pre>
                      </div>
                    </div>

                    <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' " >
                      <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored" ></PDFViewer>
                    </div>
                    <div v-if="active[0].file.toUpperCase() =='PNG'" class="global" >
                      <div class="contenido" >
                        <v-img :src="url" aspect-ratio="2" ></v-img>
                      </div>
                    </div>
                 <!--    <v-alert border="top" colored-border type="info" elevation="2"
                      v-if="active[0].file.toUpperCase() !='PDF'  && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='TXT' && active[0].file !=''" >Vista previa no disponible.
                    </v-alert> -->

                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </base-material-card>

      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import {
  request
} from "http";
import {
  mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";

export default {
  components: {
    PDFViewer
  },
  created() {
    this.getDias();
  },
  computed: {

  },
  mounted() {},
  methods: {
    getDias: async function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        rfc: this.$local_storage.get("rfc"),
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };

      let response = await axios.post(this.$hostname + 'reportes_ws/peticiones_edocuments/', data);
      self = this;
      if (response.status == 200) {
        this.dias = response.data,
          response.data.forEach(function(item) {
            self.items.push({
              id: data.rfc + "/peticiones/edocuments/" + item,
              name: item,
              dir: data.rfc + "/peticiones/edocuments/" + item,
              file: 'folder',
              size: 0
            })
          });
        this.$root.$dialogLoader.hide();
      } else {
        this.$root.$dialogLoader.hide();
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al cargar los dias disponibles",
          footer: '',
        });
      }
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    preview() {
      if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG") {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.xmlError = false;
        var datos = {
          id: this.active[0].dir,
          bucket: "production.econnect.ds"
        }
        var result = "";
        axios.post(this.$hostname + 's3/download/', datos)
          .then((response) => {
            if (typeof response.data !== 'undefined') {
              let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                  type: response.headers["content-type"]
                }),
                url = window.URL.createObjectURL(blob);
              if (this.active[0].file.toUpperCase() == "PDF") {
                this.url = url;
              }
              if (this.active[0].file.toUpperCase() == "XML") {
                this.xmlContent = atob(response.data)
              }
              if (this.active[0].file.toUpperCase() == "PNG") {
                this.url = atob(response.data)
              }
            } else {
              this.url = "";
              this.xmlContent = "";
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                footer: '',
              });
            }
            this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
            this.$root.$dialogLoader.hide();
          })
          .catch((error) => {
            this.url = "";
            this.xmlContent = ""
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                footer: '',
              });
              this.$root.$dialogLoader.hide();
            } else {
              this.$swal({
                type: "info",
                title: "Importante",
                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
              }).then(result => {
                if (result.value) {
                  this.downloadFileUrl(datos.id);
                } else {
                  this.$root.$dialogLoader.hide();
                }
              });
            }
            this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

          });
      }

    },
    download() {
      if (this.active[0].file == "zip" || this.active[0].file == "folder") {
        this.generateZip(this.active[0].dir);
      } else {
        if (this.active[0].file.toUpperCase() == "XML") {
          this.downloadFile(this.active[0].dir);
        } else {
          try {
            if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
              this.downloadFileUrl(this.active[0].dir);
            else
              this.downloadFile(this.active[0].dir);
          } catch (error) {
            this.downloadFileUrl(this.active[0].dir);
          }

        }
      }

    },
    eliminar(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.active = [];
      var datos = {
        key: key
      }
      axios.post(this.$hostname + 'vucem/delete_adjunto/ ', datos)
        .then((response) => {
          //console.log(response);
          if (typeof response.data !== 'undefined') {
            this.confirm = false;
            this.$swal({
              type: "success",
              title: "Operación Exitosa!",
              text: "El archivo se eliminó correctamente",
              footer: '',
            });
            this.buscar();
          }
        })
        .catch((error) => {
          this.confirm = false;
          var mensaje = "Ocurrió un error al eliminar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.confirm = false;
          this.$root.$dialogLoader.hide();
        });

    },
    urlUpdated(url) {
      this.documentError = undefined;
      this.url = url;
    },

    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download/', datos)
        .then((response) => {

          if (typeof response.data !== 'undefined') {

            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                type: response.headers["content-type"]
              }),
              url = window.URL.createObjectURL(blob);

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            a.href = url;
            var arreglo = key.split("/")
            a.download = arreglo[arreglo.length - 1];
            a.click();

            a.parentNode.removeChild(a);
            this.$root.$dialogLoader.hide();
          } else {
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          this.$root.$dialogLoader.hide();
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        });
    },

    generateZip: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        key: key,
        usuario: this.$local_storage.get("id_usuario"),
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_zip/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            this.$swal({
              type: "info",
              title: "Generado...",
              text: "En breve recibirás una notificación para descargar el ZIP",
              footer: '',
            });
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadFileUrl: function(dir) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: dir,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });

    },
  },
  data: () => ({
    fab: false,
    xmlError: false,
    xmlContent: "",
    url: "",
    file: "",
    search: null,
    key: 1,
    active: [],
    sel: null,
    URL: "",
    dialog1: false,
    confirm: false,
    confirmExpediente: false,
    listado: "",
    files: {
      PDF: "mdi-file-pdf",
      PNG: "mdi-file-image",
      JPG: "mdi-file-image-outline",
      TXT: "mdi-file-document-outline",
      XLS: "mdi-file-excel",
      XLSX: "mdi-file-excel",
      DOCX: "mdi-file-word",
      DOC: "mdi-file-word",
      XML: "mdi-file-code-outline",
      zip: "mdi-folder-zip"
    },
    tree: [],
    items: [],
    borrable: false,
    borrableExpediente: false,
    comentario: "",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },
      {
        text: "Descarga de Evidencias",
        disabled: true,
        to: ""
      }
    ],
  })
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin-top: 0px;
}

.error {
  border: 1px solid red;
  background: pink;
  color: red;
  padding: 0.5em 3em;
  display: inline;
}

.box-shadow {
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
  overflow: hidden;
}

@media print {
  body {
    background-color: transparent;
  }

  #app {
    margin: 0;
    padding: 0;
  }
}

.global {
  margin-left: 10px;
  margin-top: 20px;
  height: 432px;
  width: 100%;
  border: 1px solid #ddd;
  background: #f1f1f1;
  overflow: scroll;
}

.tree {
  margin-left: 0px;
  margin-top: -20px;
  height: 450px;
  width: 100%;
  border: 1px solid #ddd;
  background: #f1f1f1;
  overflow-y: scroll;
}

.contenido {
  padding: 5px;
  font-size: small;
  overflow: auto;
}

.v-card__subtitle,
.v-card__text {
  line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
  min-height: 20px !important;
}

.table {
  font-size: 12px !important;
  margin-bottom: 20px;
}

.v-label {
  font-size: 8px !important;
}
</style>
